import { useState } from 'react';
import ProdSellContext from './index';
import React from 'react';
import swal from 'sweetalert';

const ProdSellProvider = ({ children }) => {
    const [productsSellList, setProductsSellList] = useState([])
    const [totalPrecio, setTotalPrecio] = useState(0)
    const [totalRevende, setTotalRevende] = useState(0)
    const [error, setError] = useState()

    const getProductLineKey = (data, priceData) => `${data.id_prod}-${priceData.sell_price}`

    const NewProdSell = async (data, cant, priceData, revendePrice) => {
        setError()
        setProductsSellList(productsSellList => {
            const lineKey = getProductLineKey(data, priceData)
            const existingIndex = productsSellList.findIndex(item => getProductLineKey(item, item.prices) === lineKey)

            if (existingIndex >= 0) {
                return productsSellList.map((item, key) => {
                    if (key !== existingIndex) {
                        return item
                    }

                    return {
                        ...item,
                        cant_prod: item.cant_prod + parseInt(cant)
                    }
                })
            }

            if (productsSellList.length > 29) {
                swal("Cantidad Máxima de Registros", "Por cuestiones de formato no se pueden registrar más de 30 productos diferentes. Se recomienda que genere esta factura y agregar otra más de ser necesario.", "error");
                return productsSellList
            }

            return [
                ...productsSellList,
                {
                    ...data,
                    orden: productsSellList.length,
                    cant_prod: parseInt(cant),
                    key: Date.now() + Math.random(),
                    prices: priceData,
                    price: priceData.sell_price,
                    revendePrice
                }
            ]
        })
    }

    const RemoveProduct = (key) => {
        const newList = productsSellList.filter(item => { return item.key !== key })
        setProductsSellList(newList)
    }

    const modifyPrice = (data, cant, priceData, revendePrice) => {
        const editedLine = {
            ...data,
            cant_prod: parseInt(cant),
            prices: priceData,
            price: priceData.sell_price,
            revendePrice
        }

        setProductsSellList(productsSellList => {
            const newList = productsSellList.filter(item => item.key !== data.key)
            const lineKey = getProductLineKey(editedLine, priceData)
            const existingIndex = newList.findIndex(item => getProductLineKey(item, item.prices) === lineKey)

            if (existingIndex >= 0) {
                const list = newList.map((item, key) => {
                    if (key !== existingIndex) {
                        return item
                    }

                    return {
                        ...item,
                        cant_prod: item.cant_prod + editedLine.cant_prod
                    }
                })
                list.sort((a, b) => a.orden - b.orden)
                return list
            }

            const list = [...newList, editedLine]
            list.sort((a, b) => a.orden - b.orden)
            return list
        })
    }

    const cancelarCompra = () => {
        setProductsSellList([])
        setTotalPrecio(0)
        setTotalRevende(0)
        setError()
    }

    return (
        <ProdSellContext.Provider value={{
            NewProdSell,
            productsSellList,
            RemoveProduct,
            totalPrecio,
            error,
            cancelarCompra,
            setTotalPrecio,
            totalRevende,
            setTotalRevende,
            modifyPrice
        }}>
            {children}
        </ProdSellContext.Provider>
    )
}
export default ProdSellProvider
